import { FC, useState } from 'react';

import { getAvatarText } from '@/components/ui/Avatar/Avatar.helpers';
import { LogoAvatarIcon } from '@/components/ui/Icons/Icons';

import * as S from './Avatar.styles';

interface AvatarProps {
  name?: string | null;
  image?: string | null;
  dataCy?: string;
  size: number;
  showInitials?: boolean;
}

export const Avatar: FC<AvatarProps> = ({
  name,
  image,
  size,
  dataCy,
  showInitials = false
}) => {
  const [isError, setIsError] = useState(false);
  const showImage = !!image && !isError;
  const computedName = name ?? 'None';

  return (
    <S.AvatarWrapper data-cy={dataCy} $withImage={showImage} $size={size}>
      {showImage ? (
        <S.AvatarImage
          draggable={false}
          onError={() => setIsError(true)}
          src={image}
          alt={computedName}
          width={size}
          height={size}
        />
      ) : !showInitials && image === null ? (
        <LogoAvatarIcon />
      ) : (
        <S.AvatarName data-testid="avatar-name" $size={size} htmlTag="h3">
          {getAvatarText(computedName)}
        </S.AvatarName>
      )}
    </S.AvatarWrapper>
  );
};
